<template>
    <div class="p-5">
        <h1 class="text-5xl text-slate-600 font-bold tracking-tight">Typography</h1>

        <div class="flex flex-wrap mt-5">

            <div class="w-full sm:w-1/2 border-r pr-5">
                <font-selector :font="model.styleGuide.header_font" text-type="Display"></font-selector>
                <font-selector :font="model.styleGuide.text_font" text-type="Text" class="my-4"></font-selector>
            </div>

            <div class="w-full sm:w-1/2">
                <div class="px-5 sm:ml-3">
                    <div class="my-2">
                        <h1 class="text-5xl text-slate-600 tracking-tight" :style="headerFontStyle">Header (h1)</h1>
                    </div>
                    <div class="my-2">
                        <h2 class="text-4xl text-slate-600 tracking-tight" :style="headerFontStyle">Header (h2)</h2>
                    </div>
                    <div class="my-2">
                        <h3 class="text-3xl text-slate-600 tracking-tight" :style="headerFontStyle">Header (h3)</h3>
                    </div>
                    <div class="my-2">
                        <h1 class="text-xl text-slate-600" :style="textFontStyle">This is some body text... look good?</h1>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import FontSelector from "./FontSelector.vue";

export default {
    name: 'Typography',
    components: {FontSelector},
    computed: {
        textFontStyle() {
            let weight = this.model.styleGuide.text_font.weight

            let fontStyle = {
                fontFamily: this.model.styleGuide.text_font.family,
                fontWeight: weight === 'regular' ? '400' : weight,
            }

            return fontStyle
        },

        headerFontStyle() {
            let weight = this.model.styleGuide.header_font.weight

            let fontStyle = {
                fontFamily: this.model.styleGuide.header_font.family,
                fontWeight: weight === 'regular' ? '400' : weight,
            }

            return fontStyle
        },
    },
    data() {
        return {
            model: webase.model
        }
    },
    mounted() {
    },
    methods: {
        importantMethodHere() {
        }
    }
}
</script>
